import { render } from "./RadioGroup.vue?vue&type=template&id=97940008&scoped=true"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import "./RadioGroup.vue?vue&type=style&index=0&id=97940008&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97940008"]])

export default __exports__